import { Button, Typography } from "@mui/material";
import AppDialog from "./AppDialog";
import rabbitMascot from "../../assets/rabbit-win-3.webp";
import { useCustomColors } from "../../hooks/useCustomColors";
import { useTranslation } from "react-i18next";
import { useContact } from "../../hooks/useContact";

export interface CTADialogProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  subtitle?: string;
  description?: string;
  note?: string;
  actionLabel?: string;
  /** Money dialogs get the rabbit; the plain support one does not. */
  mascot?: boolean;
  /** Top Up and Withdraw use `support`; general support uses `review`. */
  link?: "support" | "review";
}

const CTADialog = ({
  open,
  onClose,
  title,
  subtitle,
  description,
  note,
  actionLabel,
  mascot,
  link = "support",
}: CTADialogProps) => {
  const colors = useCustomColors();
  const { t } = useTranslation();
  const contact = useContact();
  const ctaUrl = (link === "review" ? contact.reviewUrl : contact.supportUrl) ?? undefined;

  return (
    <AppDialog
      open={open}
      onClose={onClose}
      mascot={mascot ? rabbitMascot : undefined}
      title={title || t("sign_up_account_title")}
      subtitle={subtitle || t("sign_up_account_subtitle")}
      actions={
        <Button
          component="a"
          href={ctaUrl}
          disabled={!ctaUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={onClose}
          sx={{
            height: "50px",
            borderRadius: "12px",
            px: "28px",
            flex: 1,
          }}
        >
          {actionLabel || t("sign_up_contact_support")}
        </Button>
      }
    >
      <Typography
        sx={{
          fontSize: "14px",
          lineHeight: 1.9,
          color: colors.text.primary,
        }}
      >
        {description || t("sign_up_account_description")}
      </Typography>
      <Typography
        sx={{
          mt: "12px",
          fontSize: "12.5px",
          lineHeight: 1.7,
          color: colors.text.disabled,
        }}
      >
        {note || t("sign_up_account_note")}
      </Typography>
    </AppDialog>
  );
};

export default CTADialog;
